// extracted by mini-css-extract-plugin
module.exports = {"container":"Faq_container__uD5OY","questions":"Faq_questions__X9oSp","questions--limited":"Faq_questions--limited__WI5yT","button":"Faq_button__n9JfW"};